"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPIN = void 0;
const transform_1 = require("./transform");
exports.SPIN = 'spin';
(0, transform_1.createTransformKeyFrame)(exports.SPIN, 'rotate(0deg)', 'rotate(360deg)');
//# sourceMappingURL=spin.js.map